var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTabsList',{attrs:{"tabsId":"tabsAppearanceOverrides","ariaLabel":"Coach reports","tabs":_vm.tabs,"appearanceOverrides":{
    ':hover': {
      color: 'var(--tokens-primary)',
    },
    textTransform: 'none',
    margin: '0 32px',
  },"appearanceOverridesActive":{
    borderBottomWidth: '6px',
  }},model:{value:(_vm.activeTabId),callback:function ($$v) {_vm.activeTabId=$$v},expression:"activeTabId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }